import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import TetherContext from './TetherContext';

var TetherTarget = /*#__PURE__*/function (_React$Component) {
  _inherits(TetherTarget, _React$Component);

  var _super = _createSuper(TetherTarget);

  function TetherTarget(props) {
    var _this;

    _classCallCheck(this, TetherTarget);

    _this = _super.call(this, props);
    _this.state = {};
    _this.handlePositionUpdates = _this.handlePositionUpdates.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(TetherTarget, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.context != null) {
        var _this$context = this.context,
            registerTarget = _this$context.registerTarget,
            listenToPositionUpdates = _this$context.listenToPositionUpdates; // eslint-disable-next-line @typescript-eslint/unbound-method

        listenToPositionUpdates(this.handlePositionUpdates);
        registerTarget(this);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.context != null) {
        var _this$context2 = this.context,
            stopListeningToPositionUpdates = _this$context2.stopListeningToPositionUpdates,
            unregisterTarget = _this$context2.unregisterTarget; // eslint-disable-next-line @typescript-eslint/unbound-method

        stopListeningToPositionUpdates(this.handlePositionUpdates);
        unregisterTarget();
      }
    }
  }, {
    key: "handlePositionUpdates",
    value: function handlePositionUpdates(result) {
      this.setState(result);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          component = _this$props.component,
          render = _this$props.render;
      var _this$state = this.state,
          position = _this$state.position,
          feedback = _this$state.feedback;

      if (component != null) {
        return /*#__PURE__*/React.createElement(component, {
          position: position,
          feedback: feedback
        });
      }

      if (typeof render === 'function') {
        return render({
          position: position,
          feedback: feedback
        });
      }

      if (children != null) {
        if (typeof children === 'function') {
          return children({
            position: position,
            feedback: feedback
          });
        }

        if (!Array.isArray(children) || children.length) {
          return React.Children.only(children);
        }
      }

      return null;
    }
  }]);

  return TetherTarget;
}(React.Component);

_defineProperty(TetherTarget, "displayName", 'TetherTarget');

_defineProperty(TetherTarget, "contextType", TetherContext);

export default TetherTarget;